import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_my_einvoice_from_irb_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  irb_digital_signature: fromDatatype.VarcharDatatypeInterface;
  supplier_name: fromDatatype.VarcharDatatypeInterface;
  buyer_name: fromDatatype.VarcharDatatypeInterface;
  supplier_tax_id: fromDatatype.VarcharDatatypeInterface;
  supplier_id_no: fromDatatype.VarcharDatatypeInterface;
  supplier_sales_service_tax_id: fromDatatype.VarcharDatatypeInterface;
  supplier_email: fromDatatype.VarcharDatatypeInterface;
  supplier_standard_indu_class_code: fromDatatype.VarcharDatatypeInterface;
  supplier_business_activity_desc: fromDatatype.VarcharDatatypeInterface;
  buyer_tax_id: fromDatatype.VarcharDatatypeInterface;
  buyer_id_no: fromDatatype.VarcharDatatypeInterface;
  buyer_sales_service_tax_id: fromDatatype.VarcharDatatypeInterface;
  supplier_tourism_tax_id: fromDatatype.VarcharDatatypeInterface;
  buyer_email: fromDatatype.VarcharDatatypeInterface;
  supplier_address: any;
  buyer_address: any;
  supplier_contact_no: fromDatatype.VarcharDatatypeInterface;
  buyer_contact_no: fromDatatype.VarcharDatatypeInterface;
  einvoice_ver: fromDatatype.VarcharDatatypeInterface;
  einvoice_type: fromDatatype.VarcharDatatypeInterface;
  einvoice_code_no: fromDatatype.VarcharDatatypeInterface;
  original_einvoice_ref_no: fromDatatype.VarcharDatatypeInterface;
  einvoice_datetime: fromDatatype.TimestampTzDatatypeInterface;
  validation_datetime: fromDatatype.TimestampTzDatatypeInterface;
  supplier_digital_signature: fromDatatype.VarcharDatatypeInterface;
  invoice_currency_code: fromDatatype.VarcharDatatypeInterface;
  currency_rate: fromDatatype.NumericDatatypeInterface;
  billing_frequency: fromDatatype.VarcharDatatypeInterface;
  billing_period: fromDatatype.VarcharDatatypeInterface;
  irb_doc_unique_ref_no: fromDatatype.VarcharDatatypeInterface;
  tax_exemption_amount: fromDatatype.NumericDatatypeInterface;
  sub_total: fromDatatype.NumericDatatypeInterface;
  total_exclude_tax: fromDatatype.NumericDatatypeInterface;
  total_include_tax: fromDatatype.NumericDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  posting_status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_supplier_company_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_supplier_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_buyer_company_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_buyer_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  supplier_id_type: fromDatatype.VarcharArrayDatatypeInterface;
  supplier_id_value: fromDatatype.VarcharArrayDatatypeInterface;
  buyer_id_type: fromDatatype.VarcharArrayDatatypeInterface;
  buyer_id_value: fromDatatype.VarcharArrayDatatypeInterface;
  is_consolidated: boolean;
  einvoice_delivery_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  src_einvoice_lhdn_document_guid: fromDatatype.VarcharDatatypeInterface;
  src_einvoice_lhdn_submission_guid: fromDatatype.VarcharDatatypeInterface;
  submission_channel: fromDatatype.VarcharDatatypeInterface;
  intermediary_tin: fromDatatype.VarcharDatatypeInterface;
  intermediary_name: fromDatatype.VarcharDatatypeInterface;
  src_to_irb_hdr_guid: fromDatatype.GuidDataFieldInterface;
  submission_status: fromDatatype.VarcharDatatypeInterface;
  actual_submission_date: fromDatatype.TimestampTzDatatypeInterface;
  generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_hdr_server_doc_type: fromDatatype.VarcharDatatypeInterface;
  generic_doc_hdr_server_doc_1: fromDatatype.VarcharDatatypeInterface;
  code_company: fromDatatype.VarcharDatatypeInterface;
  doc_entity_hdr_json: any;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  amount_txn: fromDatatype.NumericDatatypeInterface;
  doc_ccy: fromDatatype.VarcharDatatypeInterface;
  doc_reference: fromDatatype.VarcharDatatypeInterface;
  billing_json: any;
  delivery_entity_json: any;
  amount_tax_gst: fromDatatype.NumericDatatypeInterface;
  total_net_amount: fromDatatype.NumericDatatypeInterface;
  total_payable_amount: fromDatatype.NumericDatatypeInterface;
  allowance_total_amount: fromDatatype.NumericDatatypeInterface;
  cancellation_datetime: fromDatatype.TimestampTzDatatypeInterface;
  cancellation_by: fromDatatype.VarcharDatatypeInterface;
  einvoice_document_status: fromDatatype.VarcharDatatypeInterface;
  running_no: fromDatatype.VarcharDatatypeInterface;
  qr_code: fromDatatype.TextDatatypeInterface;
  validation_url: fromDatatype.VarcharDatatypeInterface;
  einvoice_buyer_entity_hdr_json: any;
  einvoice_supplier_entity_hdr_json: any;
  einvoice_billing_period_start: fromDatatype.TimestampTzDatatypeInterface;
  einvoice_billing_period_end: fromDatatype.TimestampTzDatatypeInterface;
}

export class bl_fi_my_einvoice_from_irb_hdr_RowClass
  implements bl_fi_my_einvoice_from_irb_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  irb_digital_signature: fromDatatype.VarcharDatatypeInterface;
  supplier_name: fromDatatype.VarcharDatatypeInterface;
  buyer_name: fromDatatype.VarcharDatatypeInterface;
  supplier_tax_id: fromDatatype.VarcharDatatypeInterface;
  supplier_id_no: fromDatatype.VarcharDatatypeInterface;
  supplier_sales_service_tax_id: fromDatatype.VarcharDatatypeInterface;
  supplier_email: fromDatatype.VarcharDatatypeInterface;
  supplier_standard_indu_class_code: fromDatatype.VarcharDatatypeInterface;
  supplier_business_activity_desc: fromDatatype.VarcharDatatypeInterface;
  buyer_tax_id: fromDatatype.VarcharDatatypeInterface;
  buyer_id_no: fromDatatype.VarcharDatatypeInterface;
  buyer_sales_service_tax_id: fromDatatype.VarcharDatatypeInterface;
  supplier_tourism_tax_id: fromDatatype.VarcharDatatypeInterface;
  buyer_email: fromDatatype.VarcharDatatypeInterface;
  supplier_address: any;
  buyer_address: any;
  supplier_contact_no: fromDatatype.VarcharDatatypeInterface;
  buyer_contact_no: fromDatatype.VarcharDatatypeInterface;
  einvoice_ver: fromDatatype.VarcharDatatypeInterface;
  einvoice_type: fromDatatype.VarcharDatatypeInterface;
  einvoice_code_no: fromDatatype.VarcharDatatypeInterface;
  original_einvoice_ref_no: fromDatatype.VarcharDatatypeInterface;
  einvoice_datetime: fromDatatype.TimestampTzDatatypeInterface;
  validation_datetime: fromDatatype.TimestampTzDatatypeInterface;
  supplier_digital_signature: fromDatatype.VarcharDatatypeInterface;
  invoice_currency_code: fromDatatype.VarcharDatatypeInterface;
  currency_rate: fromDatatype.NumericDatatypeInterface;
  billing_frequency: fromDatatype.VarcharDatatypeInterface;
  billing_period: fromDatatype.VarcharDatatypeInterface;
  irb_doc_unique_ref_no: fromDatatype.VarcharDatatypeInterface;
  tax_exemption_amount: fromDatatype.NumericDatatypeInterface;
  sub_total: fromDatatype.NumericDatatypeInterface;
  total_exclude_tax: fromDatatype.NumericDatatypeInterface;
  total_include_tax: fromDatatype.NumericDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  posting_status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_supplier_company_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_supplier_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_buyer_company_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_buyer_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  supplier_id_type: fromDatatype.VarcharArrayDatatypeInterface;
  supplier_id_value: fromDatatype.VarcharArrayDatatypeInterface;
  buyer_id_type: fromDatatype.VarcharArrayDatatypeInterface;
  buyer_id_value: fromDatatype.VarcharArrayDatatypeInterface;
  is_consolidated: boolean;
  einvoice_delivery_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  src_einvoice_lhdn_document_guid: fromDatatype.VarcharDatatypeInterface;
  src_einvoice_lhdn_submission_guid: fromDatatype.VarcharDatatypeInterface;
  submission_channel: fromDatatype.VarcharDatatypeInterface;
  intermediary_tin: fromDatatype.VarcharDatatypeInterface;
  intermediary_name: fromDatatype.VarcharDatatypeInterface;
  src_to_irb_hdr_guid: fromDatatype.GuidDataFieldInterface;
  submission_status: fromDatatype.VarcharDatatypeInterface;
  actual_submission_date: fromDatatype.TimestampTzDatatypeInterface;
  generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_hdr_server_doc_type: fromDatatype.VarcharDatatypeInterface;
  generic_doc_hdr_server_doc_1: fromDatatype.VarcharDatatypeInterface;
  code_company: fromDatatype.VarcharDatatypeInterface;
  doc_entity_hdr_json: any;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  amount_txn: fromDatatype.NumericDatatypeInterface;
  doc_ccy: fromDatatype.VarcharDatatypeInterface;
  doc_reference: fromDatatype.VarcharDatatypeInterface;
  billing_json: any;
  delivery_entity_json: any;
  amount_tax_gst: fromDatatype.NumericDatatypeInterface;
  total_net_amount: fromDatatype.NumericDatatypeInterface;
  total_payable_amount: fromDatatype.NumericDatatypeInterface;
  allowance_total_amount: fromDatatype.NumericDatatypeInterface;
  cancellation_datetime: fromDatatype.TimestampTzDatatypeInterface;
  cancellation_by: fromDatatype.VarcharDatatypeInterface;
  einvoice_document_status: fromDatatype.VarcharDatatypeInterface;
  running_no: fromDatatype.VarcharDatatypeInterface;
  qr_code: fromDatatype.TextDatatypeInterface;
  validation_url: fromDatatype.VarcharDatatypeInterface;
  einvoice_buyer_entity_hdr_json: any;
  einvoice_supplier_entity_hdr_json: any;
  einvoice_billing_period_start: fromDatatype.TimestampTzDatatypeInterface;
  einvoice_billing_period_end: fromDatatype.TimestampTzDatatypeInterface;
}
